module.exports = __webpack_public_path__ + "static/img/特色投教图标.27fc898.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/特色投教图标.gif
// module id = vppm
// module chunks = 3